/**
* @description: 提交记录列表
*/
<template>
    <div class="maintenance_record" ref="myElementRef">
        <div ref="searchBox">
            <hc-search :data="searchData" @serch="getSearch" />
        </div>
        <!-- 表格 -->
        <div class="table_box">
            <hc-table :tableData="state.tableData" :column="state.tableHeader" :offsetHeight="state.offsetHeight" :maxPage="maxPage"
                @pageChange="pageChange" @limitChange="limitChange">
                <template #status="{ row }">
                    {{ listToMap(statusOptions, {})[row.status] }}
                </template>
                <template #schedule_date="{ row }">
                    {{ formatDisplayDate(row.schedule_date) || '-' }}
                </template>
                <template #execute_time="{ row }">
                    {{ formatDisplayDateTime(row.execute_time) || '-' }}
                </template>
                <template #operation="scope">
                    <div class="btn_box_det">
                        <el-button v-if="scope.row.status === 1" class="opBtn" size="small" type="primary" link
                            @click="openAudit(scope.row)">{{ t('maintenance.audit') }}</el-button>
                        <el-button v-if="scope.row.status > 1 || scope.row.status === 0" class="opBtn" size="small" type="primary" link
                            @click="$refs['detail'].open(scope.row)">{{ t('maintenance.detail') }}</el-button>
                    </div>
                </template>
            </hc-table>
        </div>
        <!-- 新增 -->
        <!-- 审核 -->
        <Audit ref="audit" :title="t('maintenance.audit')" @refresh="getSearch(searchData)" />

        <!-- 详情 -->
        <Detail ref="detail" />
    </div>
</template>

<script setup>
import hcSearch from "@/components/hc-search/index.vue";
import hcTable from "@/components/hc-table/index.vue";
import { onMounted, reactive, ref, nextTick, onUnmounted, onActivated, toRaw, watch } from "vue";
import { useI18n } from "vue-i18n";
import { ElMessage, ElMessageBox } from 'element-plus'
import { t } from "@/locale/index.js";
import Audit from "./components/audit.vue";
import Detail from "./components/detail.vue"

import { pageListApi } from "@/api/maintenance/maintenance.js";
import { listToMap } from "@/utils/utils";
import { formatDisplayDate, formatDisplayDateTime } from "@/utils/dateTime.js";
const myElementRef = ref();
const searchBox = ref();
const audit = ref();


const { locale } = useI18n();

let page = ref(1);
let limit = ref(20);
let maxPage = ref(0);
const buildStatusOptions = () => ([
    { label: t('common.all'), value: 99 },
    { label: t('maintenance.pending'), value: 0 },
    { label: t('maintenance.pendingAudit'), value: 1 },
    { label: t('maintenance.completed'), value: 2 },
    { label: t('maintenance.overdue'), value: 3 },
    { label: t('maintenance.rejected'), value: 4 },
]);

const statusOptions = reactive(buildStatusOptions());

const applyLabels = () => {
    statusOptions.splice(0, statusOptions.length, ...buildStatusOptions());
    searchData[0].label = t('field.status');
    searchData[0].children = statusOptions;
    searchData[1].label = t('field.keywords');
    searchData[2].label = t('common.startTime');
    state.column = buildColumns();
    tableHeaderFn();
};

const buildColumns = () => ([
        { prop: "id", show: false, label: "ID" },
        { show: true, type: "index", label: t('table.index'), width: 80 },
        { prop: "code", show: true, label: t('maintenance.deviceCode') },
        { prop: "title", show: true, label: t('maintenance.deviceName') },
        { prop: "model", show: true, label: t('maintenance.model') },
        { prop: "name", show: true, label: t('field.title') },
        { prop: "content", show: true, label: t('improveDetail.taskDesc') },
        { prop: "schedule_date", show: true, label: t('common.startTime') },
        { prop: "real_name", show: true, label: t('field.realName') },
        { prop: "mobile", show: true, label: t('field.mobile') },
        { prop: "execute_time", show: true, label: t('detail.clockTime') },
        { prop: "status", show: true, label: t('field.status') },
        { prop: "operation", show: true, label: t('table.operation') },
]);

watch(locale, applyLabels);

const state = reactive({
    title: "",
    column: buildColumns(),
    offsetHeight: 0,
    tableHeader: [],
    tableData: [
        {
            // "updated_at": "2025-05-09 15:02:01",
            // "user_id": 1,
            // "mobile": "13456214521",
            // "created_at": "2025-05-09 15:02:01",
            // "task_id": 1,
            // "real_name": "张三",
            // "id": 1,
            // "replied_by": 0,
            // "status": 1,
            // "username": "jishou0001"
        }
    ]
});

const searchData = reactive([
    { label: "", type: "select", children: statusOptions, value: 99, field: 'status', defaultValue: 99, clearable: false },
    { label: "", type: "input", value: "", field: 'keywords' },
    { label: "", type: "daterange", value: [], field: 'time', seditem: '', enditem: '' },
]);

const init = () => {
    applyLabels();
    getSearch(searchData)
};

// 动态改变表头
const change = (item) => {
    tableHeaderFn();
};

const offHeighths = () => {
    if (myElementRef.value) {
        state.offsetHeight =
            myElementRef.value?.offsetHeight - 90 - searchBox.value?.offsetHeight;
    }
};

const pageChange = (currentPage) => {
    page.value = currentPage;
    getSearch(searchData)
}

const limitChange = (currentLimit) => {
    limit.value = currentLimit;
    getSearch(searchData)
}

const openAudit = (row) => {
    audit.value.open(row)
}

onMounted(() => {
    try {
        nextTick(() => {
            offHeighths();
        });
        window.onresize = () => {
            nextTick(() => {
                offHeighths();
            });
        };
        tableHeaderFn();
        init();
    } catch { }
});

onUnmounted(() => {
    window.onresize = null;
});

// 查询过来的数据
const getSearch = (params) => {
    const timeData = toRaw(searchData.filter(i => i.field === 'time')[0] ?? {}).value ?? []
    const form = listToMap(toRaw(params), { value: 'value', key: 'field' })
    const requestParams = {
        page: page.value,
        limit: limit.value,
        ...form,
        "stime": timeData[0] ?? '',
        "etime": timeData[1] ?? '',
    }
    state.loading = true
		pageListApi(JSON.stringify(requestParams)).then(res => {
        maxPage.value = res?.maxPage ?? 0;
        state.tableData = res?.data ?? []
    }).finally(() => {
		state.loading = false
	})
};

// 表头筛选
const tableHeaderFn = () => {
    state.tableHeader = state.column.filter((v) => {
        if (v.show) {
            return v.show == true;
        } else {
            v.show = false;
        }
    });
};
</script>

<style lang="less" scoped>
.maintenance_record {
    overflow: auto;
    background-color: #fff;
    border-radius: 6px;
    padding: 10px;
    margin-right: 10px;
    width: 100%;
    height: 100%;
}

.btn_box {
    height: 40px;
    display: flex;
}

.table_box {
    width: 100%;
}

/deep/.el-button-group .el-button--primary:first-child {
    background-color: #1e6aed;
    border: none;
}

.serBtn {
    margin-left: 10px;
    background-color: #f0f0f0;
    color: #000;
    border: none;
}

.serBtn:hover {
    background-color: #f0f0f0;
    color: #000;
}

.opBtn {
    // margin: 0 !important;
    margin: 0 10px 0 0;
}

.opBtn:hover {
    color: #e6a755;
}
</style>
